<template>
  <v-card :loading="loading"
    class="pa-3"
    v-if="achievement"
    flat
    :color="$vuetify.theme.dark ? '#2d2d2d' : '#f9fafb'"
    height="100%"
  >
    <v-row>
      <v-col cols="12" lg="1" md="1" sm="0" xs="0"></v-col>
      <v-col cols="12" lg="10" md="10" sm="12" xs="12">
        <v-card class="rounded-a-lg my-5 " v-if="achievement">
          <v-row class="pa-5">
            <v-col cols="12">
              <v-row dir="auto">
                <v-col cols="12" lg="6" md="6" sm="12">
                  <v-card flat>
                    <h3 class="text-title font-weight-bold">{{ achievement.title }}</h3>
                    <p dir="auto">{{ achievement.description }}</p>
                    <v-chip
                      label
                      :color="$vuetify.theme.dark ? 'green darken-4' : 'green lighten-5'"
                    >
                      {{ $t("portfolio.Achievement.date") }} :
                      {{ achievement.achievementDate | moment("YYYY/MM/DD") }}
                    </v-chip>
                  </v-card>
                </v-col>
                <v-col cols="12" lg="6" md="6" sm="12" dir="auto">
                  <div class="d-flex flex-wrap justify-center">
                    <v-card
                      class="info text-center d-flex flex-column align-center justify-center ma-1"
                      width="150"
                      min-width="150"
                      flat
                      style="height: 80px"
                      :title="achievement.createdDate | moment('YYYY-MM-DD - h:mm A')"
                    >
                      {{ $t("portfolio.general.createdDate") }}
                      <h5 class="font-weight-light font-weight-bold">
                        {{
                          new Date(achievement.createdDate).toLocaleDateString($i18n.locale, {
                            year: "numeric",
                            month: "long",
                            day: "numeric"
                          })
                        }}
                      </h5>
                    </v-card>
                    <v-card
                      v-if="achievement.modifiedDate"
                      class="info text-center d-flex flex-column align-center justify-center  ma-1"
                      width="150"
                      flat
                      min-width="150"
                      style="height: 80px"
                      :title="achievement.modifiedDate | moment('YYYY-MM-DD - h:mm A')"
                    >
                      {{ $t("portfolio.general.modifiedDate") }}
                      <h5 class="font-weight-light font-weight-bold">
                        {{
                          achievement.modifiedDate &&
                          new Date(achievement.modifiedDate).getFullYear() > 1
                            ? new Date(achievement.modifiedDate).toLocaleDateString($i18n.locale, {
                                year: "numeric",
                                month: "long",
                                day: "numeric"
                              })
                            : "-"
                        }}
                      </h5>
                    </v-card>
                    <v-card
                      class="info text-center d-flex flex-column align-center justify-center  ma-1"
                      width="150"
                      min-width="150"
                      flat
                      style="height: 80px"
                    >
                      {{ $t("studentName") }}
                      <h5 class="font-weight-light font-weight-bold">
                        {{ achievement.student.studentFullName }}
                      </h5>
                    </v-card>
                  </div>
                </v-col>

                <v-row class="ma-0 pa-0" style="gap: 1rem;">
                  <v-col cols="12">
                    <TagsMini
                      @delete="deleteTag"
                      v-model="achievement.tags"
                      :sourceGuid="achievement.achievementGuid"
                      sourceType="Achievement"
                      :showAdd="this.isInRole(0)"
                      :isRemovable="this.isInRole(0)"
                    />
                  </v-col>
                </v-row>
              </v-row>
            </v-col>
          </v-row>
        </v-card>

        <v-card class="my-6">
          <v-tabs v-model="activeTab" background-color="transparent">
            <v-tab v-for="tab in tabs" :key="tab.name" :value="tab.name">
              {{ $t(tab.name) }} {{ tab.hash==='attachments' && achievement.files.length>0  ? `(${achievement.files.length})` : '' }}
            </v-tab>
          </v-tabs>
          <v-divider></v-divider>
          <component
            style="min-height: 40rem;"
            :sourceGuid="achievement.achievementGuid"
            :ownerGuid="achievement.student.studentGuid"
            v-model="achievement.files"
            sourceType="2"
            v-if="currentComponent"
            :is="currentComponent"
          ></component
        ></v-card>
      </v-col>
      <v-col cols="12" lg="1" md="1" sm="0" xs="0"></v-col>
    </v-row>
    <AchievementsDialog ref="addAchievementDialog" @success="getAchievement" />

    <v-fab-transition v-if="this.$store.state.userData.guid === achievement.student.studentGuid">
      <v-btn
        :title="$t('edit')"
        color="secondary"
        fab
        large
        elevation="6"
        fixed
        bottom
        :left="$vuetify.rtl"
        :right="!$vuetify.rtl"
        class="v-btn--example"
        :class="$store.state.drawerMessage ? 'ml-16' : ''"
        :style="!$vuetify.rtl ? 'right:50px' : ''"
        @click="$refs.addAchievementDialog.showDialogEdit(achievement)"
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </v-fab-transition>
  </v-card>
</template>

<script>
import Comments from "../comments/index.vue";
import Feedback from "../feedback/index.vue";
import AchievementsDialog from "../../../../components/portfolio/achievements/achievementsDialog.vue";
import TagsMini from "../../../../components/portfolio/tagsMini.vue";
import Attachments from "../attachment/index.vue";

export default {
  name: "ViewAchievement",
  components: {
    Comments,
    Feedback,
    AchievementsDialog,
    TagsMini,
    Attachments
  },
  data() {
    return {
      activeTab: "portfolio.WorkSample.pages.feedback",
      tabs: [
        { name: "portfolio.WorkSample.pages.feedbacks", hash: "feedback" },
        { name: "portfolio.WorkSample.pages.comments", hash: "comments" },
        { name: "portfolio.WorkSample.pages.attachments", hash: "attachments" }
      ],
      achievement: {
        achievementGuid: null,
        title: "",
        description: "",
        achievementDate: ""
      },
      loading: true,
      error: null
    };
  },
  created() {
    this.getAchievement();

    const { tab } = this.$route.query;
    if (tab) {
      const index = this.tabs.findIndex(t => t.hash === tab);
      if (index !== -1) {
        this.activeTab = index;
      }
    }
  },
  methods: {
    getAchievement() {
      this.loading = true;

      this.axios
        .get("Achievement/Get/" + this.achievementId)
        .then(res => {
          this.achievement = res.data;
          this.loading = false;
        })
        .catch(error => {
          this.error = error;
          this.loading = false;
        });
    },
    deleteTag(index) {
      this.achievement.tags.splice(index, 1);
    }
  },
  watch: {
    activeTab(newVal) {
      const currentTab = this.$route.query.tab;
      const newTab = this.tabs[newVal].hash;
      if (currentTab !== newTab) {
        this.$router.replace({ query: { tab: newTab } });
      }
    }
  },
  computed: {
    currentComponent() {
      const map = {
        0: "Feedback",
        1: "Comments",
        2: "Attachments"
      };
      return map[this.activeTab] || "Feedback";
    },
    achievementId() {
      return this.$route.params.id;
    }
  }
};
</script>
